import {assertAndContinue} from 'Asserts';
import {Batch} from 'constants/SampleConstants';
import {ManagedModelType} from 'models/ManagedModelDefinitions';
import {ModelManager} from 'models/managers/ModelManager';
import {getStore} from 'redux-stores/Store';
import StorableStore from 'samples/StorableStore';

export class BatchModelManager extends ModelManager<ManagedModelType.BATCH> {
  constructor() {
    super(ManagedModelType.BATCH);
  }

  doFetchMulti(keys: Array<string>): Promise<void> {
    assertAndContinue(
      false,
      'BatchModelManager.doFetchMulti() was called. This is supposed to be dead code.'
    );
    return Promise.resolve();
  }

  getModel(modelKey: string): Batch | null {
    return StorableStore.getBatch(modelKey) || null;
  }

  isModelInaccessible(modelKey: string): boolean {
    return getStore().getState().models.inaccessibleBatchIds.includes(modelKey);
  }
}
